import {
    DASHBOARD_OFFERS_REQUEST, 
    DASHBOARD_OFFERS_ERROR, 
    DASHBOARD_OFFERS_SUCCESS
} from "../actions/dashboardOffersActions";

const initialState={
    data:[],
    fetching:false,
    set:false,
}

export default function dashboardOffers(state=initialState, action){
    switch (action.type){
        case DASHBOARD_OFFERS_REQUEST:
            return{
                ...state,
                fetching:true
            }
        case DASHBOARD_OFFERS_ERROR:
            return{
                ...state,
                fetching:false                
            }
        case DASHBOARD_OFFERS_SUCCESS:
            return{
                ...state,
                fetching:false,
                set:true,
                data:action.payload       
            }
        default:
            return state;
        }
        
}


// WEBPACK FOOTER //
// ./src/reducers/dashboardOffers.js